<template>
	<el-row>
		<!-- 左边 -->
		<el-col :span="6">
			<div>
				<div ref="leftBox" class="leftBox">
					<el-tabs v-model="activeType" stretch @tab-click="handleClick" style="margin-right: 20px;">
						<el-tab-pane label="操作手册" name="OPERATION_MENU"></el-tab-pane>
						<el-tab-pane label="常见问题" name="COMMON_PROBLEM"></el-tab-pane>
					</el-tabs>
					<div style="margin-right: 20px;">
						<el-input v-model="filterText" size="small" placeholder="请输入标题" class="filter-type-select">
              <el-select slot="prepend" v-model="filterType" clearable style="width: 100px" v-if="activeType == 'COMMON_PROBLEM'">
                <template v-for="item in dict.HELP_PROBLEM_TYPE">
                  <el-option :id="item.id" :label="item.label" :value="item.value"></el-option>
                </template>
              </el-select>
						</el-input>
					</div>

					<div class="scrollbar-hidden" style="flex: 1; margin-bottom: 20px;margin-top: 10px;overflow-y: scroll" v-loading="treeLoading">
						<el-tree
							class="tree"
							ref="tree"
							:data="treeData"
							:props="treeProps"
							node-key="id"
							@node-click="nodeClick"
							:filter-node-method="filterNode">
							<div class="custom-tree-node node" slot-scope="{ node, data }">
								<el-badge :is-dot="data.status== 0">{{ node.label }}</el-badge>
							</div>
						</el-tree>
					</div>
				</div>
			</div>
		</el-col>
		<!-- 右边 -->
		<el-col :span="18">
      <div class="flex-box" style="display: flex;">
        <div ref="rightBox" :class="['rightBox', activeType == 'COMMON_PROBLEM' ? 'common-problem-bg' : 'operation-menu-bg']" style="" v-loading="treeLoading">
          <div>
            <help-tree :data="contentList" :active="activeId"></help-tree>
          </div>
        </div>
        <div class="video-list" v-if="activeType == 'OPERATION_MENU' && contentList && contentList.length && contentList[0].videoUrl">
          <video :src="contentList[0].videoUrl" style="width: 90%;outline: 5px solid #375676;" controls></video>
          <div class="video-remark">
            {{ contentList[0].videoRemark }}
          </div>
        </div>
      </div>
		</el-col>
	</el-row>

</template>

<script>

import helpCenterApi from '@/api/helpCenter/helpCenter'
import helpTree from './helpTree'
import helpPlayer from './helpPlayer'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {deepClone} from '@/utils/index'

export default {
  dicts: ['HELP_PROBLEM_TYPE','HELP_TYPE', 'HELP_PUBLISH_STATUS'],
  components: { helpTree, Treeselect, helpPlayer },
  props: {
  },
  data() {
    return {
      treeData: [],
      treeLoading: false,
      treeProps: {
        children: 'childList',
        label: 'title',
        value: 'titleCode'
      },
      activeType: 'OPERATION_MENU',
      filterText: '',
      filterType: '',
      videoList: [],
      contentList: [],

      activeId: '',
    }
  },
  watch: {
  },
  mounted() {
    this.getHelpTree()
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    filterType(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    // 点击切换 tab
    handleClick(tab, event) {
      this.filterText = ''
      this.filterType = ''
      this.getHelpTree()
    },
    // 节点点击(不包括箭头)
    nodeClick(data,node,vm) {
      // 操作手册点击显示对应详情和视频
      if (this.activeType == 'OPERATION_MENU') {
        let contentData = deepClone(data)
        delete contentData.childList
        this.contentList = [contentData]
      }
      // 常见问题显示全部，点击滚动到对应问题
      else {
        this.activeId = data.id
        let rightBox = this.$refs.rightBox
        rightBox.scrollTo({
          top: rightBox.querySelector("#" + 'anchor' + data.id).offsetTop - 100,
          left: 0,
          behavior: 'smooth'
        })
      }
    },
    // 关键字筛选
    filterNode(val, data) {
      if (data.title.indexOf(this.filterText) == -1) {
        return false
      }
      else if(this.activeType == 'COMMON_PROBLEM' && this.filterType && data.problemType != this.filterType) {
        return false
      }
      return true
    },
    // 获取帮助树
    getHelpTree() {
      this.treeLoading = true
      let query = {}
      query.helpType = this.activeType
      query.status = '1'
      this.contentList = []
      helpCenterApi.getTree(query).then( res => {
        if (query.helpType == this.activeType) {
          this.treeData = res || []
          this.treeLoading = false
          if (this.activeType == 'COMMON_PROBLEM') {
            this.contentList = this.treeData
          }
        }
      }).catch(() => {
        this.treeLoading = false
      })
    },
    findNode(list, childKey, key, value) {
      for(let i = 0; i < list.length; i++) {
        if (list[i][key] == value) {
          return list[i]
        }
        else if (list[i][childKey] && list[i][childKey].length) {
          return this.findNode(list[i][childKey])
        }
      }
      return null
    }
  }
}
</script>

<style scoped lang="scss">

	.leftBox{
		padding: 0 0 0 20px;
		display: flex;
		flex-direction: column;
    height: 100vh;
    border:1px solid rgba(0, 0, 0, 0.06);
	}
	.rightBox{
		overflow-y: scroll;
    border: 1px solid rgba(0, 0, 0, 0.06);
    height: 100vh;
    flex: 1.3;
		>div{
			padding: 20px;
		}
	}
  .operation-menu-bg {
    background: linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.9)), url(~@/assets/images/operation_menu_bg.png);
    background-position: 90% 90%;
    background-repeat: no-repeat;
  }
  .common-problem-bg {
    background: linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.9)), url(~@/assets/images/common_problem_bg.png);
    background-position: 90% 90%;
    background-repeat: no-repeat;
  }
	.handleBox{
		height: 100%;
		display: flex;
		flex-direction: column;
	}
	.node{
		// width: calc(100%);
		padding-right: 22px;
		box-sizing: border-box;
		overflow:hidden;
		white-space:nowrap;
		text-overflow:ellipsis;
		/deep/ .is-dot{
			width: 10px;
			height: 10px;
			top: 3px;
			right: 0;
		}
	}
	.handleMenu{
		// display: none;
		margin: 2px 0;
		// display: flex;
		// justify-content: center;
		// align-items: center;
		width: 20px;
		position: absolute;
		top: 0;
		right: 10px;
		text-align: center;
		background-color: #fff;
		border-radius: 3px;
	}
	/deep/ .el-tree-node__content:hover{
		.handleMenu{
			display: inline-block;
			background-color: #F5F7FA;
		}
		.handleMenu:hover{
			background-color: #b0b1b3;
		}
	}
	/deep/ .el-tooltip__popper.is-light {
		background-color: #eee !important;
	}
	.btn{
		border: none;
	}

	/deep/ .tree .el-tree-node {
		position: relative;
	}
  .filter-type-select /deep/.el-input-group__prepend {
    background-color: #fff;
  }
  .cover-upload-hidden /deep/.el-upload--picture-card {
    display: none;
  }
  .menu-tree {
    /deep/.el-icon-caret-right:not(.is-leaf)+.el-checkbox {
      display: none;
    }
  }
  .video-list {
    flex: 1;
    padding: 100px 20px;
    text-align: center;
    ul {
      list-style: none;
      padding-left: 0;
    }
    .video-remark {
      color: #7b7b7b;
      font-size: 12px;
      line-height: 20px;
      padding-top: 15px;
      padding-left: 10px;
      text-align: left;
    }
  }

.scrollbar-hidden {
  /* 隐藏滚动条 */
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* Webkit 浏览器 */
  &::-webkit-scrollbar {
      display: none;
  }
}
</style>
